import { EdiStatus } from '@api/Trinium/Endpoints/EDI/types';
import { DatePickerRangeValue } from '@forms/Components/DateRangePicker';
import { Dayjs } from 'dayjs';
import { Dispatch, PropsWithChildren, SetStateAction, createContext, useContext } from 'react';

export const EdiLoadTenderContext = createContext<EdiLoadTenderContext>({} as EdiLoadTenderContext);

/**
 * React Context to store and access relative api parameters throughout the data grid.
 */
export default function EdiLoadTendersContextProvider(props: { ctxValue: EdiLoadTenderContext } & PropsWithChildren) {
	return <EdiLoadTenderContext.Provider value={props.ctxValue}>{props.children}</EdiLoadTenderContext.Provider>;
}

/** Hook to access the nearest Edi Load Tender Context Provider */
export function useEdiLoadTenderContext() {
	const context = useContext(EdiLoadTenderContext);
	return context;
}

interface EdiLoadTenderContext {
	ediStatus: keyof typeof EdiStatus;
	setEdiStatus: Dispatch<SetStateAction<keyof typeof EdiStatus>>;
	modifyDateFrom: Dayjs | null;
	modifyDateTo: Dayjs | null;
	setDateRange: Dispatch<SetStateAction<DatePickerRangeValue>>;
}
